enum ResourceTypes {
  Message = "1",
  Job = "2",
  Payslip = "3",
  WorkOrder = "4",
}

export default ResourceTypes;
